module.exports = __webpack_public_path__ + "static/img/logo.8cd1184.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/logo.png
// module id = d0r6
// module chunks = 1